'use client'

import PlausibleProvider from 'next-plausible'
import { PropsWithChildren } from 'react'

export interface AnalyticsProviderProps {
  domain: string
}

const ANALYTICS_ENABLED = process.env.NEXT_PUBLIC_ANALYTICS_ENABLED === 'true'

export function AnalyticsProvider({ children, domain }: PropsWithChildren<AnalyticsProviderProps>) {
  if (!ANALYTICS_ENABLED) {
    return children
  }

  return <PlausibleProvider domain={domain}>{children}</PlausibleProvider>
}
